// extracted by mini-css-extract-plugin
export default {"root":"z7sS566WKx4WqGXWr3BQ","node":"yRAfiopIZqXT8LZv3Xwx"};